const features = [
  {
    icon: 'ri-speed-up-line',
    title: '更新速度全网第一',
    desc: '51吃瓜网今日吃瓜采用智能抓取 + 人工审核双引擎，从事件发生到推送上线平均仅需3分钟。每日吃瓜精选专题更是实时滚动更新，让你永远快人一步吃到最新鲜的瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '匿名保护绝对安全',
    desc: '所有投稿爆料均经过多层加密和脱敏处理。51吃瓜群众无需注册即可围观，投稿者身份信息采用业界领先的零知识证明方案，任何人也无法追溯到你的真实身份。',
  },
  {
    icon: 'ri-stack-line',
    title: '资源覆盖全面深入',
    desc: '全网最新吃瓜资源一网打尽——娱乐圈、社会热点、网红八卦、电竞圈、影视吐槽……你想到的和想不到的吃瓜资源合集都在这里。每日500+条内容更新，总有一条让你欲罢不能。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          <i className="ri-star-line text-primary-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 mb-8 text-center">为什么51吃瓜群众都选择我们</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/60 rounded-xl p-6 md:p-7 text-center group hover:border-primary-200 transition-colors duration-200 cursor-pointer"
            >
              <div className={`w-14 h-14 mx-auto mb-5 rounded-xl flex items-center justify-center ${
                i === 0 ? 'bg-primary-50' : i === 1 ? 'bg-accent-50' : 'bg-secondary-50'
              }`}>
                <i className={`${item.icon} text-2xl ${
                  i === 0 ? 'text-primary-500' : i === 1 ? 'text-accent-500' : 'text-secondary-500'
                } w-7 h-7 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base font-bold font-heading text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}